import { MultiPathSVG } from "../../SVG"
import styled from "styled-components"
import React from "react"

interface XButtonProps {
  onClick?: () => void
}

function XButton({ onClick }: XButtonProps): JSX.Element {
  return (
    <div className="db dn-ns absolute top-0 right-0">
      <button className="bn pa4 bg-transparent" onClick={onClick}>
        <MultiPathSVG iconName="icn-close" />
      </button>
    </div>
  )
}

const DrawerNonActiveBackground = styled.div<{ active: string }>`
  pointer-events: none;
  z-index: 10;
  height: 100%;
  width: 100%;
  top: 0;
  position: absolute;

  @media screen and (max-width: 599px) {
    ${({ active }) =>
      active &&
      `
    pointer-events: auto;
    opacity: 50%;
    background: black;
    position: fixed;
  `}
  }
`

const DrawerContainer = styled.div<{ active: string }>`
  transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  position: relative;
  width: 100%;
  height: inherit;
  top: 0;
  pointer-events: none;
  z-index: 10;
  @media screen and (max-width: 599px) {
    transform: translateX(-100%);
    position: fixed;
    ${({ active }) =>
      active &&
      `
    transform: translateX(0%);
  `}
  }
`

const DrawerBackground = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  position: relative;
  background-color: #f4f2ef;
  pointer-events: auto;
  @media screen and (max-width: 599px) {
    height: 100vh;
    margin-right: 80px;
  }
`

export { XButton, DrawerNonActiveBackground, DrawerContainer, DrawerBackground }
